import * as ActionTypes from 'automation-ui-canvas/actions/ActionTypes';
import { getBulkProcessingRootByFlowId } from 'automation-ui-canvas/selectors/platformFlowsApplicationSelectors';
export function addFlowEnableErrors(errors) {
  return {
    type: ActionTypes.ADD_FLOW_ENABLE_ERRORS,
    errors
  };
}
export function removeFlowEnableErrors(errorIds) {
  return {
    type: ActionTypes.REMOVE_FLOW_ENABLE_ERRORS,
    errorIds
  };
}
export function testFlowWithObject(flowId, objectId, options) {
  return {
    type: ActionTypes.TEST_FLOW_WITH_OBJECT,
    flowId,
    objectId,
    options
  };
}
export function highlightActions(actionIds) {
  return {
    type: ActionTypes.HIGHLIGHT_ACTIONS,
    actionIds
  };
}
export function setBulkProcessingStatus(flowId, bulkProcessingStatus) {
  return function (dispatch, getState) {
    const state = getState();
    const currBulkProcessingStatus = getBulkProcessingRootByFlowId(flowId)(state);
    if (!currBulkProcessingStatus.equals(bulkProcessingStatus)) {
      dispatch({
        type: ActionTypes.SET_BULK_PROCESSING_STATUS,
        flowId,
        bulkProcessingStatus
      });
    }
  };
}
export function setBulkProcessingPollingStatus(flowId, shouldPollBulkProcessing) {
  return {
    type: ActionTypes.SET_BULK_PROCESSING_POLLING_STATUS,
    flowId,
    shouldPollBulkProcessing
  };
}
export function setCanvasVirtualRenderingToDisabled(isCanvasVirtualRenderingDisabled) {
  return {
    type: ActionTypes.SET_CANVAS_VIRTUAL_RENDERING,
    isCanvasVirtualRenderingDisabled
  };
}
export const setIsInResolutionMode = isInResolutionMode => ({
  type: ActionTypes.SET_RESOLUTION_MODE,
  payload: {
    isInResolutionMode
  }
});
export const closedActionConfigRelaxedValidation = () => ({
  type: ActionTypes.CLOSED_ACTION_CONFIG_RELAXED_VALIDATION
});
export const openedActionConfigRelaxedValidation = actionHasValidationErrors => ({
  type: ActionTypes.OPENED_ACTION_CONFIG_RELAXED_VALIDATION,
  payload: {
    actionHasValidationErrors
  }
});